import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { observer } from 'mobx-react-lite';
import './UserProfileModal.css'; 
import TextButton from '../TextButton/TextButton';
import EasyInput from '../EasyInput/EasyInput'; 
import { globalStore } from '../../models/globalStore';
import { UserApi } from '../../apis/User';

interface UserProfileModalProps {
  isModalVisible: boolean;
  close: () => void;
}

const UserProfileModal: React.FC<UserProfileModalProps> = observer(({ isModalVisible, close }) => {
  const [isEditNicknameModalVisible, setIsEditNicknameModalVisible] = useState(false);
  const [isPasswordModalVisible, setIsPasswordModalVisible] = useState(false); 
  const [passwordData, setPasswordData] = useState<{ oldPassword: string; newPassword: string; confirmPassword: string }>({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [nickname, setNickname] = useState(globalStore.currentUser?.nickname || ''); 

  const updateUserInfo = async (fields: { nickname?: string; password?: string; address?: string; recipientName?: string }) : Promise<boolean> => {
    try {  
      const phone = globalStore.currentUser?.phone || '';
      if(!phone){
        return false;
      }
      const ok = await UserApi.updateUserInfo(phone, fields);
      return ok;
    } catch (error) {
      console.error('获取用户分享数据出错:', error);
      return false;
    }
  }; 

  const updateNickname = async () => {
    const updateResult:boolean  = await updateUserInfo({ nickname });  
    if (updateResult) {
        if(globalStore.currentUser){
            globalStore.currentUser.nickname = nickname;
        } 
        setIsEditNicknameModalVisible(false);
    } else {
        alert('昵称更新失败，请重试');
    }
  };

  const updatePassword = async () => {
    if(passwordData.newPassword !== passwordData.confirmPassword){
        alert('两次输入的密码不一致');
        return;
    }
    const updateResult:boolean  = await updateUserInfo({ password: passwordData.newPassword });  
    if (updateResult) {
        setIsPasswordModalVisible(false);
    } else {
        alert('密码更新失败，请重试');
    }
  }; 

  return (
    <>
      {/* 个人资料弹框 */}
      <Modal
        open={isModalVisible}
        onCancel={close}
        footer={null} 
        className="user-profile-modal"
      >
        <div className="modal-content profile-container">
            <div className='personal-profile'>个人资料</div>

            <div className="profile-header">
              <div className="avatar">{(globalStore.currentUser?.nickname || '友').slice(0,1)}</div>
              <div className="header-text">
                <div className="header-title">你好，<span className='nickname'>{globalStore.currentUser?.nickname}</span></div>
                <div className="header-subtitle">欢迎回来</div>
              </div>
              <div className="header-actions">
                <TextButton  color='#f08319' text="修改昵称" onClick={() => setIsEditNicknameModalVisible(true)} />
                <TextButton  color='#f08319' text="修改密码" onClick={() => setIsPasswordModalVisible(true)} />
              </div>
            </div>

            <div className="info-section">
              <div className="info-item">
                <div className="info-label">手机号</div>
                <div className="info-value">{globalStore.currentUser?.phone}</div>
                <div className="info-action"><span className="link" onClick={()=>{}} style={{opacity:0.5, cursor:'not-allowed'}}>不可修改</span></div>
              </div> 
            </div> 
        </div>
      </Modal>

      {/* 修改昵称弹框 */}
      <Modal
        open={isEditNicknameModalVisible}
        onCancel={() => setIsEditNicknameModalVisible(false)}
        footer={null}
        className="user-profile-modal"
      >
        <div className="modal-content">
          <div className="modal-title">修改昵称</div>
          <EasyInput
            label="输入新的昵称"
            value={nickname}
            onChange={setNickname}
            type={0}
            width="60%"
            height="50px"
          />
          <Button className="confirm-button" style={{marginTop:'20px'}} onClick={updateNickname}>
            确认修改
          </Button>
        </div>
      </Modal>

      {/* 修改密码弹框 */}
      <Modal
        open={isPasswordModalVisible}
        onCancel={() => setIsPasswordModalVisible(false)}
        footer={null}
        className="user-profile-modal"
      >
        <div className="modal-content">
          <div className="modal-title">修改密码</div>
          <div className='pwd-container'>
            <EasyInput
                    label="旧密码"
                    value={passwordData.oldPassword}
                    onChange={(value) => setPasswordData({ ...passwordData, oldPassword: value })}
                    type={4}
                    width="60%"
                    height="50px"
                />
                <EasyInput
                    label="新密码"
                    value={passwordData.newPassword}
                    onChange={(value) => setPasswordData({ ...passwordData, newPassword: value })}
                    type={4}
                    width="60%"
                    height="50px"
                />
                <EasyInput
                    label="再次输入"
                    value={passwordData.confirmPassword}
                    onChange={(value) => setPasswordData({ ...passwordData, confirmPassword: value })}
                    type={4}
                    width="60%"
                    height="50px"
                />
                <Button className="confirm-button" onClick={updatePassword}>
                    确认修改
                </Button>
          </div>
        </div>
      </Modal> 
    </>
  );
});

export default UserProfileModal;